import React, {Suspense} from 'react';
import BaseLayer from "./BaseLayer";
import {drawLine, imagetoCanvasPosHelper} from "../utils/map_utils";
import {Grid} from "@mui/material";
const Plot = React.lazy(() => import("react-plotly.js"));

class FocusPair extends BaseLayer {
    id = "focusPair";
    label = "Focus Pairs";
    defaultVisible = this.props.tileViewerState[this.id];

    onFeatureSelect = () => undefined;

    draw = () => new Promise((resolve, reject) => {
        let {x_fields, tile_height, uperpixel} = this.props.slide;
        let {focusPairs, deviceSettings, textColor} = this.props;
        console.debug("focusPairs", focusPairs);
        Object.values(focusPairs).forEach(focusPairData => {
            console.debug("focusPair", focusPairData);
            const orderedCellKeys = focusPairData['orderedCellKeys'];
            const firstCellKey = orderedCellKeys[0];
            let xImagePos = parseInt(firstCellKey.split("y")[0].split("x")[1]);
            let yImagePos = parseInt(firstCellKey.split("y")[1]);

            let abDistances = focusPairData['abDistances'];
            let maxVal = Math.max(...abDistances);
            let minVal = Math.min(...abDistances);
            let abDistancesNorm = abDistances.map(dist => (dist - minVal)/(maxVal - minVal));
            
            let lDistances = focusPairData['ldistances'];
            let maxVall = Math.max(...lDistances);
            let minVall = Math.min(...lDistances);
            let lDistancesNorm = lDistances.map(dist => (dist - minVall)/(maxVall - minVall));

            var scatterABDistances = {
                x: orderedCellKeys,
                y: abDistances,
                type: 'scatter',
                name: 'AB Distances',
            };
            var scatterABDistancesNorm = {
                x: orderedCellKeys,
                y: abDistancesNorm,
                type: 'scatter',
                name: 'AB Distances Norm.',
            };
            console.debug("abDistancesNorm", abDistancesNorm);
            var scatterLDistances = {
                x: orderedCellKeys,
                y: lDistances,
                type: 'scatter',
                name: 'L Distances',
            };
            var scatterLDistancesNorm = {
                x: orderedCellKeys,
                y: lDistancesNorm,
                type: 'scatter',
                name: 'L Distances Norm.',
            };

            var bestPairAB = {
                x: [focusPairData['bestUsingAbDist1'], focusPairData['bestUsingAbDist2']],
                y: [1.0, 1.0],
                mode: 'markers',
                name: 'AB Dist. Best Pair',
                text: ['Left Cell', 'Right Cell'],
                marker: {
                    color: 'rgb(142, 124, 195)',
                    size: 12
                },
                type: 'scatter'
            };

            var bestPairL = {
                x: [focusPairData['bestUsingLDist1'], focusPairData['bestUsingLDist2']],
                y: [1.2, 1.2],
                mode: 'markers',
                name: 'L Dist. Best Pair',
                text: ['Left Cell', 'Right Cell'],
                marker: {
                    color: 'rgb(255, 217, 102)',
                    size: 12
                },
                type: 'scatter'
            };

            var dataNorm = [scatterABDistancesNorm, scatterLDistancesNorm, bestPairAB, bestPairL];
            var data = [scatterABDistances, scatterLDistances, bestPairAB, bestPairL];
            var layout = {
                title:'AB and L Distance Plot'
            };

            let popup = 
                <Grid><Suspense fallback={<div>Loading...</div>}><Plot data={dataNorm} layout={layout}/></Suspense></Grid>;
            let popup2 = 
                <Grid><Suspense fallback={<div>Loading...</div>}><Plot data={data} layout={layout}/></Suspense></Grid>;
            
            let {x, y} = imagetoCanvasPosHelper({device_settings: deviceSettings}, this.props.slide, x_fields - xImagePos, yImagePos);
            let radius = 10;
            drawLine(x + 0.5 * tile_height * uperpixel - radius, y - 0.8 * tile_height * uperpixel - radius, 1, this.layer.getSource(),
                        "[DIST. PLOT Norm]", 10, "#f4c2c2", popup, textColor, 10);
            drawLine(x + 0.5 * tile_height * uperpixel - radius, y - 0.9 * tile_height * uperpixel - radius, 1, this.layer.getSource(),
                        "[DIST. PLOT]", 10, "#f4c2c2", popup2, textColor, 10);
        });
        resolve();
    });
}

export default FocusPair;